import { FC, PropsWithChildren } from "react";
import Box from "../Box";

const Container: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box width="100%" maxWidth="90%" margin="auto" marginBottom={30}>
      {children}
    </Box>
  );
};

export default Container;
